import type { utils } from 'blockly/core';

import { categoryCssConfig, categorySubCssConfig } from '../categoryCssConfig.js';
import { BEGINNER_LED_COLOR } from './constants.js';

type ToolboxItemInfo = utils.toolbox.ToolboxItemInfo;

/** Beginner LED category with Standard, Pixel, and RGB subcategories. */
export function buildBeginnerLedCategory(): ToolboxItemInfo {
  return {
    kind: 'category',
    name: 'LED',
    colour: String(BEGINNER_LED_COLOR),
    cssconfig: categoryCssConfig('led'),
    contents: [
      {
        kind: 'category',
        name: 'Standard LED',
        colour: String(BEGINNER_LED_COLOR),
        cssconfig: categorySubCssConfig('led'),
        contents: [
          { kind: 'block', type: 'beginner_std_led_turn' },
          { kind: 'block', type: 'beginner_std_led_blink' },
          { kind: 'block', type: 'beginner_std_led_brightness' },
          { kind: 'block', type: 'beginner_led_on' },
          { kind: 'block', type: 'beginner_led_off' },
          { kind: 'block', type: 'beginner_blink_led' },
        ],
      },
      {
        kind: 'category',
        name: 'Pixel LED',
        colour: String(BEGINNER_LED_COLOR),
        cssconfig: categorySubCssConfig('pixel-led'),
        contents: [
          { kind: 'block', type: 'beginner_pixel_configure' },
          { kind: 'block', type: 'beginner_pixel_set_color' },
          { kind: 'block', type: 'beginner_pixel_set_all' },
          { kind: 'block', type: 'beginner_pixel_clear' },
          { kind: 'block', type: 'beginner_pixel_show' },
          { kind: 'block', type: 'beginner_pixel_brightness' },
          { kind: 'block', type: 'beginner_pixel_effect' },
        ],
      },
      {
        kind: 'category',
        name: 'RGB LED',
        colour: String(BEGINNER_LED_COLOR),
        cssconfig: categorySubCssConfig('rgb-led'),
        contents: [
          { kind: 'block', type: 'beginner_rgb_configure' },
          { kind: 'block', type: 'beginner_rgb_set_color' },
          { kind: 'block', type: 'beginner_rgb_turn_off' },
          { kind: 'block', type: 'beginner_rgb_brightness' },
        ],
      },
    ],
  };
}
